export const headerSnykAuthFailed = 'snyk-auth-failed';
